import React from 'react';

import { VerifyPersonalInfoContents } from '../../components';
import { IdentityProvider } from '../../context';

// TODO: Make generic version of verification screen
export function NewHDVerifyPersonalInfoScreen() {
  return (
    <IdentityProvider>
      <VerifyPersonalInfoContents resource="healthcare-directive" steps={6} nextPath="" />
    </IdentityProvider>
  );
}

export function ScreenHeader({ handleBack, steps, step, title, description }) {
  return (
    <div className="screen-header">
      {handleBack && <BackButton handleBack={handleBack} dark={false} />}
      <div className="screen-title">
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
      <div className="progress-info">
        <p>Step {step} of {steps}</p>
        <p>{Math.floor((step - 1) / steps * 100)}% Complete</p>
      </div>
      <div className="progress-bar">
        <div className="progress-bar-fill" style={{ width: `calc(100%/${steps}*${step})` }}></div>
      </div>
    </div>
  );
}

export function BackButton({ dark, handleBack }) {
  return (
    <span className={`back-button ${dark ? 'dark' : ''}`} onClick={handleBack}>
      &lt; Back
    </span>
  );
}
